import { render, staticRenderFns } from "./EventsDialog.vue?vue&type=template&id=03413df2&scoped=true&"
import script from "./EventsDialog.vue?vue&type=script&lang=js&"
export * from "./EventsDialog.vue?vue&type=script&lang=js&"
import style0 from "./EventsDialog.vue?vue&type=style&index=0&id=03413df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03413df2",
  null
  
)

/* custom blocks */
import block0 from "./EventsDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports